import React from 'react';
import './style.scss';

export const CardSelect = ({
  num = 'one',
  title,
  onClick,
  customIcon = null,
  text,
  titleClassName,
  children,
  hideHeader = false,
  hideTitle = false,
  hideContent = false,
  style,
  customTitle,
}) => {
  return (
    <div className='pdp_card_select card_wrap' onClick={onClick} style={style}>
      {!hideHeader && (
        <div className={`card_header ${num}`}>
          {customIcon ? (
            <img src={customIcon} alt='' />
          ) : (
            <i className='fas fa-code'></i>
          )}
        </div>
      )}
      {!hideContent && (
        <div className='card_content'>
          {!hideTitle && (
            <h1 className={`card_title ${titleClassName}`}>{title}</h1>
          )}
          {customTitle}
          <p className='card_text'>{text}</p>
        </div>
      )}
      {children}
    </div>
  );
};
